import api from "./api";
import { Producto, ProductosResponse } from "../types";

const API_URL = "/productos";
const CACHE_KEY_PREFIX = 'productos_cache_';

export const clearProductCache = () => {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith(CACHE_KEY_PREFIX)) {
      localStorage.removeItem(key);
    }
  });
};

export const getProductos = async (page: number = 1, limit: number = 10): Promise<ProductosResponse> => {
  const cacheKey = `${CACHE_KEY_PREFIX}${page}_${limit}`;

  try {
    const cachedData = localStorage.getItem(cacheKey);
    if (cachedData) {
      return JSON.parse(cachedData);
    }

    const response = await api.get(`${API_URL}?page=${page}&limit=${limit}`);
    localStorage.setItem(cacheKey, JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    console.error("Error al obtener productos", error);
    return { productos: [], pagination: { totalItems: 0, totalPages: 0, currentPage: 1, limit: 10 } };
  }
};

// Obtener un producto por ID
export const getProductoById = async (id: number): Promise<Producto> => {
  try {
    const response = await api.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener producto con ID ${id}`, error);
    throw error;
  }
};

// Crear un nuevo producto
export const createProducto = async (producto: Partial<Producto>): Promise<Producto> => {
  try {
    const response = await api.post(API_URL, producto);
    clearProductCache();
    return response.data;
  } catch (error) {
    console.error("Error al crear producto", error);
    throw error;
  }
};

// Actualizar un producto por ID
export const updateProducto = async (id: number, producto: Partial<Producto>): Promise<Producto> => {
  try {
    const response = await api.put(`${API_URL}/${id}`, producto);
    clearProductCache();
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar el producto con ID ${id}`, error);
    throw error;
  }
};

// Eliminar un producto por ID
export const deleteProducto = async (id: number): Promise<{ message: string }> => {
  try {
    const response = await api.delete(`${API_URL}/${id}`);
    clearProductCache();
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar el producto con ID ${id}`, error);
    throw error;
  }
};

// Buscar productos por query con paginación
export const searchProductos = async (query: string, page: number = 1, limit: number = 10): Promise<ProductosResponse> => {
  try {
    const response = await api.get(`${API_URL}/buscar?query=${encodeURIComponent(query)}&page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error(`Error al buscar productos con query "${query}"`, error);
    return { productos: [], pagination: { totalItems: 0, totalPages: 0, currentPage: 1, limit: 10 } };
  }
};


export const descargarInventarioExcel = async (): Promise<void> => {
  const response = await api.get(
    `${API_URL}/export`,
    { responseType: 'blob' }
  );

  // Intentamos obtener el nombre del archivo del header
  const disposition = response.headers['content-disposition'];
  let fileName = 'inventario.xlsx';
  if (disposition && disposition.indexOf('filename=') !== -1) {
    const match = disposition.match(/filename="?(.+)"?/);
    if (match && match.length > 1) fileName = match[1] as string;
  }

  // Forzar descarga en navegador
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};